{
  "header": {
    "title": "Chat",
    "subtitle": "Your AI fitness coach"
  },
  "mobileHeader": {
    "title": "AI Coach",
    "back": "Go back",
    "history": "Chat history"
  },
  "input": {
    "placeholder": "Generate workout focused on chest..."
  },
  "list": {
    "title": "Chats",
    "newChat": "New chat",
    "close": "Close",
    "searchPlaceholder": "Search chats...",
    "defaultName": "Chat session",
    "actions": "Chat options",
    "delete": "Delete",
    "deleteTitle": "Delete chat?",
    "deleteDescription": "This conversation will be permanently removed.",
    "sections": {
      "today": "Today",
      "yesterday": "Yesterday",
      "previous7Days": "Previous 7 days",
      "older": "Older"
    }
  },
  "response": {
    "muscleTargets": "Muscle targets:",
    "category": "Category:",
    "activities": "Activities",
    "sportActivities": "Sport Activities",
    "intensity": {
      "low": "Low",
      "medium": "Medium",
      "high": "High"
    },
    "muscles": {
      "BICEPS": "Biceps",
      "TRICEPS": "Triceps",
      "FOREARMS": "Forearms",
      "QUADRICEPS": "Quadriceps",
      "HAMSTRINGS": "Hamstrings",
      "CALVES": "Calves",
      "GLUTES": "Glutes",
      "PECTORALIS_MAJOR": "Chest (Pectoralis Major)",
      "PECTORALIS_MINOR": "Chest (Pectoralis Minor)",
      "LATISSIMUS_DORSI": "Lats (Latissimus Dorsi)",
      "TRAPEZIUS": "Traps (Trapezius)",
      "RHOMBOIDS": "Rhomboids",
      "DELTOIDS": "Shoulders (Deltoids)",
      "ROTATOR_CUFF": "Rotator Cuff",
      "RECTUS_ABDOMINIS": "Abs (Rectus Abdominis)",
      "OBLIQUES": "Obliques",
      "LOWER_BACK": "Lower Back",
      "HEART": "Cardiovascular"
    },
    "muscleGroups": {
      "ARMS": "Arms",
      "LEGS": "Legs",
      "CHEST": "Chest",
      "BACK": "Back",
      "SHOULDERS": "Shoulders",
      "CORE": "Core",
      "CARDIOVASCULAR": "Cardiovascular"
    }
  }
}
